'use client';
import { EntryFields } from 'contentful';
import { TypeBlockRichText } from '@fm-nx/contentful-types';
import { richTextRender } from '@fm-nx/rich-text';

export interface TextRichCenteredProps {
    // Support both block format and raw rich text
    blockRichText?: TypeBlockRichText<'WITHOUT_UNRESOLVABLE_LINKS'>;
    textBlock?: EntryFields.RichText;
    mode?: 'dark' | 'light';
}

export function TextRichCentered(props: TextRichCenteredProps) {
    const { blockRichText, textBlock } = props;

    // Support both formats: block or raw rich text
    const richText = textBlock || blockRichText?.fields?.richText;

    if (!richText) return null;

    return (
        <div className="relative w-full mx-auto max-w-container">
            <div className="py-10 mx-6 lg:mx-0">
                <div className="block">
                    <div className="prose prose--general">{richTextRender(richText)}</div>
                </div>
            </div>
        </div>
    );
}

export default TextRichCentered;
